import { lazy } from 'react'
import suspenseComponent from '../../../util/suspenseComponent'

const InputAddressGeoLazy = lazy(() => import('./InputAddressGeo'))
const InputAddressGeo = suspenseComponent(InputAddressGeoLazy)

export default InputAddressGeo
